import { Redirect, useParams } from "react-router-dom";

const IntegrationRouteRedirect = ({
  organizationId,
}: {
  organizationId: number;
}) => {
  const { slug } = useParams<{ slug: string }>();
  return (
    <Redirect
      to={`/settings/organization/${organizationId}/integrations?open=${slug}`}
    />
  );
};

export default IntegrationRouteRedirect;
